import { debounceStorage } from "../../../../..";
import { validateSideTab } from "@utils/general";
import { sanitize, validateBankDetails } from "@utils/validation";

const FORM_VALIDATION_DELAY = 150;

export const paymentMiddleware = async (action: { payload: { name: string; value: any } }, next: any) => {
  switch (action.payload.name) {
    // all actions that are not in the switch statement are passed to the next middleware
    // in the chain, or ultimately to the reducer.
    // Actions below are handled by this middleware.
    // All cases directly below are related to validating the customer form on care plan stage 3.
    case "CarePlanPaymentBankDetailsSortCode":
      action.payload.value = sanitize(action.payload.value, "SortCode");
      {
        const validateInputAndForm = () => {
          validateBankDetails("CarePlanPaymentBankDetails", "SortCode", action.payload.value);
          validateSideTab("CarePlanPaymentBankDetails");
        }
        debounceStorage.addOrExecute({ name: action.payload.name, delay: FORM_VALIDATION_DELAY, callback: validateInputAndForm });
      }
      return next(action);

    case "CarePlanPaymentBankDetailsAccountNumber":
      action.payload.value = sanitize(action.payload.value, "AccountNumber");
      {
        const validateInputAndForm = () => {
          validateBankDetails("CarePlanPaymentBankDetails", "AccountNumber", action.payload.value);
          validateSideTab("CarePlanPaymentBankDetails");
        }
        debounceStorage.addOrExecute({ name: action.payload.name, delay: FORM_VALIDATION_DELAY, callback: validateInputAndForm });
      }
      return next(action);

    case "CarePlanPaymentBankDetailsBankBranchName":
      action.payload.value = sanitize(action.payload.value, "BranchName");
      {
        const validateInputAndForm = () => {
          validateBankDetails("CarePlanPaymentBankDetails", "BranchName", action.payload.value);
          validateSideTab("CarePlanPaymentBankDetails");
        }
        debounceStorage.addOrExecute({ name: action.payload.name, delay: FORM_VALIDATION_DELAY, callback: validateInputAndForm });
      }
      return next(action);
  }
};
